import { Center, Text, VStack } from '@chakra-ui/react'

import { NOT_FOUND_STATE_TEXTS, type TabletNotFoundStateVariant } from '../model/constants'

interface TabletNotFoundStateProps {
    variant: TabletNotFoundStateVariant
}

export const TabletNotFoundState = ({ variant }: TabletNotFoundStateProps) => {
    const { title, description } = NOT_FOUND_STATE_TEXTS[variant]

    return (
        <Center bg='bg.subtle' flexDirection='column' gap='6' minH='100dvh' px='6' w='full'>
            <VStack gap='3'>
                <Text color='text.fg' fontSize='heading' fontWeight='semibold' textAlign='center'>
                    {title}
                </Text>
                <Text color='gray.600' fontSize='2xl' textAlign='center'>
                    {description}
                </Text>
            </VStack>
        </Center>
    )
}
